import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ProductList/ProductListTimelineItem.tsx
import { useRef } from "react";
import { ProductCardTimelineItem } from "../ProductCard/ProductCardTimelineItem.mjs";
import { ProductList } from "./ProductList.mjs";
import { jsx } from "react/jsx-runtime";
function ProductListTimelineItem({ products, loading = false, storeDomain, onAddToCart }) {
  const streamedRef = useRef(loading);
  if (loading) {
    streamedRef.current = true;
  }
  if (!loading && (!products || products.length === 0)) {
    return null;
  }
  const singleProduct = products.length === 1 ? products[0] : void 0;
  if (singleProduct && !loading && !streamedRef.current) {
    return /* @__PURE__ */ jsx(
      ProductCardTimelineItem,
      {
        product: singleProduct,
        loading,
        storeDomain,
        onAddToCart
      }
    );
  }
  return /* @__PURE__ */ jsx("div", { className: "buyscout-timeline-product-list", children: /* @__PURE__ */ jsx(ProductList, { products, loading, storeDomain, onAddToCart }) });
}
export {
  ProductListTimelineItem
};
//# sourceMappingURL=ProductListTimelineItem.mjs.map